import importCss from "babel-plugin-dual-import/importCss";

module.exports = {
  timesheets: () =>
    Promise.all([
      import(/* webpackChunkName: "timesheets" */
      /* webpackMode: "lazy" */
      "../timesheets"),
      importCss("timesheets")
    ]),
  timesheetData: () =>
    Promise.all([
      import(/* webpackChunkName: "timesheetData" */
      /* webpackMode: "lazy" */
      "../timesheetData"),
      importCss("timesheetData")
    ]),
  timesheetInsights: () =>
    Promise.all([
      import(/* webpackChunkName: "timesheetInsights" */
      /* webpackMode: "lazy" */
      "../timesheetInsights"),
      importCss("timesheetInsights")
    ]),
  approvals: () =>
    Promise.all([
      import(/* webpackChunkName: "approvals" */
      /* webpackMode: "lazy" */
      "../approvals"),
      importCss("approvals")
    ]),
  news: () =>
    Promise.all([
      import(/* webpackChunkName: "news" */
      /* webpackMode: "lazy" */
      "../news"),
      importCss("news")
    ]),
  articleEditor: () =>
    Promise.all([
      import(/* webpackChunkName: "articleEditor" */
      /* webpackMode: "lazy" */
      "../articleEditor"),
      importCss("articleEditor")
    ]),
  information: () =>
    Promise.all([
      import(/* webpackChunkName: "information" */
      /* webpackMode: "lazy" */
      "../information"),
      importCss("news")
    ]),
  payroll: () =>
    Promise.all([
      import(/* webpackChunkName: "payroll" */
      /* webpackMode: "lazy" */
      "../payroll"),
      importCss("payroll")
    ]),
  leave: () =>
    Promise.all([
      import(/* webpackChunkName: "leave" */
      /* webpackMode: "lazy" */
      "../leave"),
      importCss("leave")
    ]),
  profile: () =>
    Promise.all([
      import(/* webpackChunkName: "profile" */
      /* webpackMode: "lazy" */
      "../profile"),
      importCss("profile")
    ]),
  search: () =>
    Promise.all([
      import(/* webpackChunkName: "search" */
      /* webpackMode: "lazy" */
      "../search"),
      importCss("search")
    ]),
  content: () =>
    Promise.all([
      import(/* webpackChunkName: "content" */
      /* webpackMode: "lazy" */
      "../content"),
      importCss("content")
    ]),
  forms: () =>
    Promise.all([
      import(/* webpackChunkName: "forms" */
      /* webpackMode: "lazy" */
      "../forms"),
      importCss("forms")
    ]),
  useradmin: () =>
    Promise.all([
      import(/* webpackChunkName: "useradmin" */
      /* webpackMode: "lazy" */
      "../userAdmin"),
      importCss("useradmin")
    ]),
  orgsearch: () =>
    Promise.all([
      import(/* webpackChunkName: "orgsearch" */
      /* webpackMode: "lazy" */
      "../orgSearch"),
      importCss("orgsearch")
    ]),
  insights: () =>
    Promise.all([
      import(/* webpackChunkName: "insights" */
      /* webpackMode: "lazy" */
      "../insights"),
      importCss("insights")
    ]),
  portaladmin: () =>
    Promise.all([
      import(/* webpackChunkName: "portaladmin" */
      /* webpackMode: "lazy" */
      "../portalAdmin"),
      importCss("portaladmin")
    ]),
  ruletableadmin: () =>
    Promise.all([
      import(/* webpackChunkName: "ruletableadmin" */
      /* webpackMode: "lazy" */
      "../ruleTables"),
      importCss("ruletableadmin")
    ]),
  toolBuilder: () =>
    Promise.all([
      import(/* webpackChunkName: "toolBuilder" */
      /* webpackMode: "lazy" */
      "../toolBuilder"),
      importCss("toolBuilder")
    ])
};



// WEBPACK FOOTER //
// ./src/apps/shared/chunks.js